'use client'

import { useEffect } from 'react'

/**
 * Removes the redundant `?id=` param from the address bar. Links to laws
 * always carry the normId because abbreviations are not guaranteed to be
 * unique — but when the abbreviation is unique, the clean URL is canonical
 * and is what users should see and share.
 */
export default function StripIdParam() {
  useEffect(() => {
    const url = new URL(window.location.href)
    if (!url.searchParams.has('id')) return
    url.searchParams.delete('id')
    window.history.replaceState(window.history.state, '', url)
  }, [])

  return null
}
